<template>
    <component
        v-if="isLocal"
        class="base-icon local-icon"
        :style="{ '--fill': fill, width, height }"
        :is="localIcon"
        v-on="$listeners"
    />
    <div
        v-else
        class="base-icon"
        :style="{ width, height }"
        v-lazy:background-image="
            `${iconUrl}?d=${width.replace('px', '')}x${height.replace(
                'px',
                ''
            )}`
        "
        v-on="$listeners"
    />
</template>

<script>
import { getStorybookDefaults } from '@/constants';

function getIconStorybookControls(componentName, categoryName = '') {
    const category = categoryName || componentName;
    return {
        [`${componentName}Fill`]: {
            name: 'Color',
            control: { type: 'color' },
            table: { category },
        },
        [`${componentName}Width`]: {
            name: 'Width',
            table: { category },
            control: { type: 'text' },
        },
        [`${componentName}Height`]: {
            name: 'Height',
            table: { category },
            control: { type: 'text' },
        },
    };
}

export function getIconProps(props, componentName) {
    return {
        fill: props[componentName + 'Fill'],
        width: props[componentName + 'Width'],
        height: props[componentName + 'Height'],
    };
}

export function getIconStorybookHelpers(
    componentName,
    categoryName = '',
    defaultStyles
) {
    return {
        controls: getIconStorybookControls(componentName, categoryName),
        defaults: defaultStyles
            ? getStorybookDefaults(componentName, defaultStyles)
            : {},
    };
}

export default {
    name: 'BaseIcon',
    props: {
        height: {
            type: String,
            default: '20px',
        },
        width: {
            type: String,
            default: '20px',
        },
        fill: {
            type: String,
            default: '#333',
        },
        isLocal: {
            type: Boolean,
            default: false,
        },
        showPlaceholder: {
            type: Boolean,
        },
        iconSource: {
            type: String,
        },
    },
    computed: {
        iconUrl() {
            return `${this.$globalConstants.imageUrl}/img/icons/${this.iconSource}.svg`;
        },
        localIcon() {
            const icon = this.iconSource;
            return () => import(`@icons/${icon}.svg`);
        },
    },
};
</script>

<style lang="scss">
.local-icon {
    path {
        fill: var(--fill);
    }
    circle {
        stroke: var(--fill);
    }
}

.local-icon.fill-stroke {
    stroke: var(--fill);
    path {
        fill: none;
    }
}
</style>
